export default __webpack_public_path__ + "static/media/tp_logo_animated_white.17a90cb8.gif";